// This file was automatically generated from apphome.scheduler.dialog.html.
// Please don't edit this file by hand.

goog.provide('el8.template.apphome.scheduler.dialog');

goog.require('soy');
goog.require('soy.StringBuilder');
goog.require('el8.template.practicedata.appts');


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.apphome.scheduler.dialog.apptHistory = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  output.append('<div class="overlayContainer"><div class="el8AlignRight appt-search-box-container"><div class="apptSearch ebs-form-group ebs-has-feedback"><div class="apptSearchWrap"><input type="text" id="appt-search-patient" class="ebs-form-control" /></div></div></div><div class="apptListButtonContainer appt-list-button-container fr ebs-pull-right"><ul class="ebs-list-inline"><li class="el8ButtonItem"><button type="button" data-action="create-appt" class="ebs-btn ebs-btn-default">+ Create Appointment</button></li><li class="el8ButtonItem"><button type="button" data-action="refresh" class="ebs-btn ebs-btn-default">Refresh</button></li></ul></div><a class="patient-trigger el8PtName"></a><div class="patientInfoDetails appt-patient-info-details"><span class="patient-dob elt"></span><span class="patient-age elt"></span></div><div id="appt-search-future-appts" class="spacer5"><h4 class="el8SectionHeader appt-list-header"><span class="appt-list-status el8Elt"></span>Upcoming Appointments</h4><ol class="appt-list spacer5 futureApptContainer ebs-list-unstyled"></ol></div><div id="appt-search-past-appts" class="spacer5"><h4 class="el8SectionHeader appt-list-header"><span class="appt-list-status el8Elt"></span>Past Appointments</h4><ol class="appt-list spacer5 pastApptContainer ebs-list-unstyled"></ol></div></div>');
  if (!opt_sb) return output.toString();
};


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.apphome.scheduler.dialog.apptSearchEntry = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  output.append('<li class="appt-search-entry el8ApptItem', (opt_data.editable) ? ' el8ItemHover' : '', '" data-id="', soy.$$escapeHtml(opt_data.id), '"><div class="el8ApptTime el8HistoricDateWidth">', (soy.$$escapeHtml(opt_data.apptTime)? el8.service.tz.soyDateTime(soy.$$escapeHtml(opt_data.apptTime)) : ''), '</div><p class="el8ApptEntry el8EntrywithHistoricDate">');
  if (opt_data.apptType) {
    el8.template.practicedata.appts.typeTag(opt_data.apptType, output);
  } else {
    output.append('Appointment ');
  }
  output.append('with ', soy.$$escapeHtml(opt_data.physicianFullName), ' ', (opt_data.description) ? '-- ' + soy.$$escapeHtml(opt_data.description) + ' ' : '', '<span class="el8AppColor">[', soy.$$escapeHtml(opt_data.displayStatus), ']</span></p></li>');
  if (!opt_sb) return output.toString();
};


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.apphome.scheduler.dialog.apptSearchList = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  var apptList6858 = opt_data.appts;
  var apptListLen6858 = apptList6858.length;
  if (apptListLen6858 > 0) {
    for (var apptIndex6858 = 0; apptIndex6858 < apptListLen6858; apptIndex6858++) {
      var apptData6858 = apptList6858[apptIndex6858];
      el8.template.apphome.scheduler.dialog.apptSearchEntry(soy.$$augmentData(apptData6858, {editable: opt_data.editable}), output);
    }
  } else {
    output.append('<p class="el8FeedEmpty">no ', soy.$$escapeHtml(opt_data.type), ' appointments found</p>');
  }
  if (!opt_sb) return output.toString();
};
